import { datadogLogs } from "@datadog/browser-logs";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const MAX_HISTORY_LENGTH = 10;

export const DatadogRouteTracker: React.FC = () => {
  const { pathname } = useLocation();
  const historyRef = useRef<Array<{ path: string; timestamp: string }>>([]);

  useEffect(() => {
    const entry = {
      path: pathname,
      timestamp: new Date().toISOString(),
    };

    historyRef.current = [...historyRef.current.slice(-(MAX_HISTORY_LENGTH - 1)), entry];

    datadogLogs.setGlobalContextProperty("browsingHistory", historyRef.current);
  }, [pathname]);

  return null;
};
